import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-validation-demo',
  templateUrl: './validation-demo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe]
})
export class ValidationDemoComponent {
  @Output() public validate = new EventEmitter<void>();
  @Output() public reset = new EventEmitter<void>();
}
